export const fields = [
  {
    label: 'Razão Social:',
    name: 'corporateName',
  },
  {
    label: 'Endereço:',
    name: 'address.street',
  },
  {
    label: 'CNPJ:',
    name: 'documentNumber',
  },
  {
    label: 'Número:',
    name: 'address.number',
  },
  {
    label: 'Telefone:',
    name: 'localPhone',
  },
  {
    label: 'Complemento:',
    name: 'address.complement',
  },
  {
    label: 'Celular:',
    name: 'phone',
  },
  {
    label: 'Bairro:',
    name: 'address.district',
  },
  {
    label: 'Email:',
    name: 'email',
  },
  {
    label: 'Cidade:',
    name: 'address.city',
  },
  {
    label: 'Regional:',
    name: 'regional.name',
    omitable: true,
  },
  {
    label: 'Estado:',
    name: 'address.state',
  },
  {
    span: true,
  },
  {
    label: 'CEP:',
    name: 'address.postalCode',
  },
];
